<template>
	<MainLayout>
		<div class="container">
			<div class="box">
				<div class="text-right">
					<b-button  variant="warning" @click="$refs['my-modal-api-request-map'].show()" class="mr-2">Reporte Cotizaciones</b-button>
					<b-modal ref="my-modal-api-request-map" size="xl">
						<QuotesModule></QuotesModule>
					</b-modal>
					<b-button variant="info" class="mr-2" @click="exchangeRatesModal = true" >Tipos de cambio</b-button>
					<b-button variant="primary" @click="newModel" v-if="$hasPermission('pointOfSale.add')" >Nuevo punto de venta</b-button>
				</div>
				<h2>Puntos de venta</h2>
				<hr>
				<b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'suppliers-index-list') } ">
					<div class="row mb-3">
						<b-form-group class="col-2" label="Buscar">
							<b-form-input v-model="filters.search" type="text" @input="onActivityFilterChange"/>
						</b-form-group>

						<b-form-group
							class="col-4"
							label="Canales de venta">
							<multiselect
							:options="salesChannelsOpts"
							v-model="filters.salesChannelId"
							:multiple="false"
							:show-labels="false"
							label="name"
							track-by="id"
							@input="onActivityFilterChange">
								<template v-slot:clear >
								<div class="multiselect__clear" @click="clearActivityFilter"></div>
								</template>
							</multiselect>
						</b-form-group>

						<b-form-group
							class="col-4"
							label="Última actividad de ventas">
							<multiselect
							:options="activityOpts"
							v-model="filters.activity"
							:multiple="false"
							:show-labels="false"
							label="name"
							track-by="id"
							@input="onActivityFilterChange">
								<template v-slot:clear >
								<div class="multiselect__clear" @click="clearActivityFilter"></div>
								</template>
							</multiselect>
						</b-form-group>

						<b-form-group class="col-2" label=".">
							<b-button type="submit" variant="primary">Buscar</b-button>
						</b-form-group>

					</div>
				</b-form>

				<hr/>
				<b-row>
					<b-col align-self="end" class="text-right">
						<b-button
							@click="excel()"
							variant="success"
							class="ml-2 mb-2"
							:disabled="loadingExport">
							<b-spinner v-if="loadingExport" small class="mr-1"></b-spinner>
							{{ loadingExport ? 'Exportando...' : 'Exportar XLS' }}
						</b-button>
					</b-col>
				</b-row>


				<AjaxTable
					permission-show="pointOfSale.show"
					id="suppliers-index-list"
					:filters="processedFilters"
					:columns="modelColumns"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					resource="point-of-sales"
				>
					<template v-slot:cell(actions)="row">
						<div class="text-center">
							<b-button @click="(event) => openEdit(row.item.id)" type="button" size="sm" class="mr-1" variant="info">
								<md-icon icon="edit" />
							</b-button>
							<b-button v-if="$hasPermission('pointOfSale.delete')" @click="(event) => deleteModel(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="danger">
								<md-icon icon="delete" />
							</b-button>
						</div>
					</template>
				</AjaxTable>
			</div>
			<hr>
		</div>
		<Single :unableEdit.sync="unableEdit" ref="single" :success-callback="successCallback" />
		<EchangeRates v-model="exchangeRatesModal" />
	</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import AjaxTable from '../../helpers/AjaxTable.vue'
import Single from './Single.vue'
import EchangeRates from './EchangeRates.vue'
import api from '../../../api.js'
import QuotesModule from "../../sections/reports/singles/Quotes.vue"
import Multiselect from 'vue-multiselect'

export default {
		components: { MainLayout, Single, AjaxTable, EchangeRates ,QuotesModule, Multiselect},
		data(){
				return {
					filters : {
						search:'',
						activity: '',
						salesChannelId: ''
					},
					activityOpts: [
						{id: 'no_sales_since_creation', name: 'Sin ventas desde su creación'},
						{id: 'no_sales_1_month', name: 'Sin ventas hace más de 1 mes'},
						{id: 'no_sales_3_months', name: 'Sin ventas hace más de 3 meses'},
						{id: 'no_sales_6_months', name: 'Sin ventas hace más de 6 meses'},
						{id: 'no_sales_12_months', name: 'Sin ventas hace más de 12 meses'}
					],
					modelColumns : [
						{key:'id',label:'ID', sortable: true},
						{key:'codename',label:'Nombre codigo', sortable: true},
						{key:'domain',label:'Dominio', sortable: true}, //Nueva columna
						{key:'status',label:'Estado'},
						{key:'lastSale',label:'Última venta'},
						{key:'salesChannel',label:'Canal de venta'},
						{key:'actions',label:'Acciones'},
					],
					sortBy: 'id',
					sortDesc: true,
					unableEdit: false,
					exchangeRatesModal: false,
					loadingExport: false,
				}
		},
		computed: {
			processedFilters() {
				const processed = {...this.filters}
				
				// Convertir el array de objetos activity a un array de IDs
				if (this.filters.activity && this.filters.activity != '') {
					processed.activity = this.filters.activity.id
				} else {
					processed.activity = ''
				}

				if (this.filters.salesChannelId && this.filters.salesChannelId != '') {
					processed.salesChannelId = this.filters.salesChannelId.id
				} else {
					processed.salesChannelId = ''
				}
				
				return processed
			},
			salesChannelsOpts() {
                let aux= [...this.$root.auxVars.salesChannelsOpts.map((sc) => ({
                    id: sc.id,
                    name: sc.code,
                }))];

				aux.unshift({ id: 'without_saleschannel', name: "Sin canal venta" });

                return aux;
            },
		},
		methods:{
			openEdit(id){
				this.unableEdit = !this.$hasPermission('pointOfSale.edit')
				this.$refs['single'].loadModel(id)
			},
			successCallback(){
				this.$root.$emit('bv::refresh::table', 'suppliers-index-list')
			},
			newModel(){
				this.unableEdit = false
				this.$refs['single'].loadModel(-1)
			},
			deleteModel(item){
				this.$root.showWarning({
					okAction: (event, setLoading, close) => {
						setLoading(true)
						api(this).delete(`/point-of-sales/${item.id}`).then(() => {
							this.$root.showAlert('Registro Eliminado!',{variant:'warning'})
							this.$root.$emit('bv::refresh::table', 'suppliers-index-list')
							close()
						}).catch( err => {
							this.$root.handleRequestError(err)
							close()
						});
					}
				})
			},
			onActivityFilterChange() {
				// Refrescar la tabla cuando cambie el filtro de actividad
				this.$nextTick(() => {
					this.$root.$emit('bv::refresh::table', 'suppliers-index-list')
				})
			},
			clearActivityFilter() {
				this.filters.activity = ""
				this.filters.salesChannelId = ""
				this.$nextTick(() => {
					this.$root.$emit('bv::refresh::table', 'suppliers-index-list')
				})
			},
			excel() {
				this.loadingExport = true;
				api(this)
					.get(`/point-of-sales/exportXls`, {
						params: { filters: this.processedFilters },
						responseType: "blob"
					})
					.then(res => {
						this.$root.downloadExcel(res, "PuntosDeVenta");
					})
					.catch(err => {
						this.$root.handleRequestError(err);
					})
					.finally(() => {
						this.loadingExport = false;
					});
			}
		},
		mounted() {
			this.$root.auxVars.loadResourcesOpts({
				vm: this, 
				resourceNames: [
					'salesChannelsOpts',
				]
			})
		}
}
</script>

<style>

</style>
